/** 256-bit access token, base64url (43 chars). Only its SHA-256 is stored on the server. */
export function newAccessToken(): string {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  let binary = '';
  for (const b of bytes) binary += String.fromCharCode(b);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function newIdempotencyKey(): string {
  return crypto.randomUUID();
}
